import { ComplexPackageCounselorFieldOption } from "@3gaam/api/types/store";
import { create } from "zustand";
import { immer as immerMiddleware } from "zustand/middleware/immer";

interface State {
  selectedGoal: ComplexPackageCounselorFieldOption | undefined;
  selectedExamDateId: number | null | undefined;
  selectedCustomExamDate: string | null | undefined;
  packageId: undefined | number;

  setSelectedGoal: (
    packageId: number,
    selectedGoal: ComplexPackageCounselorFieldOption | undefined,
  ) => void;
  setSelectedDate: ({
    packageId,
    selectedCustomExamDate,
    selectedExamDateId,
  }: {
    packageId: number;
    selectedExamDateId?: number | null | undefined;
    selectedCustomExamDate?: string | null | undefined;
  }) => void;
  resetPackageSettings: () => void;
}

export const usePackageSettings = create<State>()(
  immerMiddleware((set, get) => ({
    selectedGoal: undefined,
    selectedExamDateId: undefined,
    selectedCustomExamDate: undefined,
    packageId: undefined,
    setSelectedDate: ({
      packageId,
      selectedCustomExamDate,
      selectedExamDateId,
    }) => {
      let lastPackageId = get().packageId;
      let lastSelectedGoal = get().selectedGoal;
      set((state) => {
        (state.packageId = packageId),
          (state.selectedCustomExamDate = selectedCustomExamDate);
        state.selectedExamDateId = selectedExamDateId;
        state.selectedGoal =
          lastPackageId === packageId ? lastSelectedGoal : undefined;
      });
    },
    setSelectedGoal: (packageId, selectedGoal) => {
      let lastPackageId = get().packageId;
      let lastSelectedExamDateId = get().selectedExamDateId;
      let lastSelectedCustomExamDate = get().selectedCustomExamDate;
      set((state) => {
        (state.packageId = packageId),
          (state.selectedGoal = selectedGoal),
          (state.selectedCustomExamDate =
            lastPackageId === packageId
              ? lastSelectedCustomExamDate
              : undefined);
        state.selectedExamDateId =
          lastPackageId === packageId ? lastSelectedExamDateId : undefined;
      });
    },
    resetPackageSettings: () => {
      set((state) => {
        state.packageId = undefined;
        state.selectedCustomExamDate = undefined;
        state.selectedExamDateId = undefined;
        state.selectedGoal = undefined;
      });
    },
  })),
);
